import React, { useEffect, useState } from 'react';
import { usePage } from '@inertiajs/inertia-react';
import Layout from '../Shared/Layout';
import useViewport from '../Components/useViewport';
import { Embed } from 'hyvor-talk-react';
import {SardiusPlayer} from "../Components/Player/SardiusPlayer";
import { DiscoverDrawer, DonateDrawer, PrayerDrawer, ReadDrawer, LibraryDrawer } from "../Components/Drawers";
import { TabBar } from "../Components/TabBar";
import { FeaturedBannerSmall } from "../Components/FeaturedBannerSmall";
import AppHead from '../Shared/AppHead';
import List from "../Components/List/List";
import ListItem from "../Components/ListItem";
import {BiChevronRight} from "react-icons/bi";

const UserWatch = ({
                      featuredOffers,
                      praiseReports,
                      libraryMedia,
                      dgi,
                      discover,
                      terms,
                      assetId,
                      title,
                      mediaId,
                  }) => {
    const { width } = useViewport();
    const breakpoint = 1024;
    const { imgixURL } = usePage().props;
    const [openTermsModal, setOpenTermsModal] = useState(false);

    // Library tab is only active on desktop
    const [activeTab, setActiveTab] = useState(
        width < breakpoint ? '' : 'library'
    );

    // send analytics
    useEffect(() => {
        if (activeTab) {
            gtag('event', 'openWatchTab', {'event_category': 'on-demand', 'event_label': activeTab});
        }
    }, [activeTab]);

    return (
        <>
        
        <AppHead title={title + " - Digital Resource"} />

        <div className='relative mt-3'>
            <div className='container' data-theme='jpm'>
                <div className='row min-h-[80vh]'>
                    <div className='col-12 lg:col-8'>

                    <SardiusPlayer assetId={assetId} title={title} />

                        <div className='md:hidden'>
                            <div className='w-full'>
                                <div className='flex items-center justify-between mb-4'>
                                    <h2 className='text-xl font-bold'>Featured Offers</h2>
                                    <a href={'/offers'}>
                                        <BiChevronRight size="24px"/>
                                    </a>
                                </div>
                                <List
                                    elements={featuredOffers}
                                    totalElements={featuredOffers.length}
                                    viewportWidth={789}
                                    listItem={el => (
                                        <ListItem
                                            imageUrl={`https://${imgixURL}/${el.product_image}`}
                                            heading={'Featured Offer'}
                                            title={el.title}
                                            isHorizontalScroll={true}
                                            description={el.shortDescription}
                                            link={el.link}
                                        />)}
                                />
                            </div>
                        </div>

                        <div className='row'>
                            <div className='col-12'>
                                <div className='w-full mt-4 mb-4 border-t border-solid border-[#7D7D7D]'></div>
                                <h2 className="text-lg font-semibold text-left md:text-center mb-1">Share your thoughts
                                    with <br className="md:hidden"/>our community</h2>
                                {terms && (
                                    <p className="text-sm text-neutral-content text-left md:text-center">By sharing your
                                        comment, you are agreeing to the following <a href="#"
                                                                                      onClick={() => setOpenTermsModal(true)}
                                                                                      className="border-b-primary border-b b-solid">terms
                                            and conditions</a>.</p>
                                )}
                            </div>
                            <div className='row mb-4'>
                                <div className='col-12'>
                                    <Embed
                                        websiteId={'7171'}
                                        id={assetId}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/*Terms Modal*/}
                    {terms && (
                        <div className={`modal z-[100000] ` + (openTermsModal ? 'modal-open' : '')} onClick={() => setOpenTermsModal(false)} style={{backgroundColor: 'rgba(40,40,42,0.8)'}}>
                            <div className="modal-box max-w-md relative bg-neutral rounded p-0 mt-2 md:mt-0" onClick={() => setOpenTermsModal(false)}>
                                <button onClick={() => setOpenTermsModal(false)} className="btn btn-sm btn-circle absolute right-2 top-2 bg-transparent border-none">✕</button>
                                <div className="p-4">
                                    <h2 className="text-xl font-bold mb-4">{terms.title}</h2>
                                    <div className="text-sm prose" dangerouslySetInnerHTML={{__html: terms.content}}>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* desktop right , mobile tabs */}
                    <div className='col-12 lg:col-4'>
                        <div className='hidden md:flex'>
                            <div className='w-full'>
                                <div className='flex items-center justify-between'>
                                    <h2 className='text-xl font-bold'>Featured Offers</h2>
                                    <a href={'/offers'}>
                                        <BiChevronRight size="24px"/>
                                    </a>
                                </div>
                                <List
                                    elements={featuredOffers}
                                    totalElements={featuredOffers.length}
                                    viewportWidth={789}
                                    listItem={el => (
                                        <ListItem
                                            imageUrl={`https://${imgixURL}/${el.product_image}`}
                                            heading={'Featured Offer'}
                                            title={el.title}
                                            isHorizontalScroll={true}
                                            description={el.shortDescription}
                                            link={el.link}
                                        />)}
                                />
                            </div>
                        </div>
                        <div className='rounded border border-[#373737] md:h-0 lg:h-auto'>
                            <TabBar activeTab={activeTab} setActiveTab={setActiveTab}/>
                            <ReadDrawer
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                praiseReports={praiseReports}
                                dgi={dgi}
                            />
                            <PrayerDrawer activeTab={activeTab} setActiveTab={setActiveTab}/>
                            <DiscoverDrawer
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                items={discover}
                            />
                            <DonateDrawer activeTab={activeTab} setActiveTab={setActiveTab}/>
                            <LibraryDrawer
                                activeTab={activeTab}
                                setActiveTab={setActiveTab}
                                libraryItems={libraryMedia}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

// Persistent layout Docs: https://inertiajs.com/pages#persistent-layouts
UserWatch.layout = (page) => (
    <Layout title='UserWatch' children={page} data-theme='jpm' />
);

export default UserWatch;
